<template>
    <Badge
        v-if="!(value === null || value === '')"
        :status="color"
        :text="text"
    />
</template>

<script>
export default {
    props: {
        value: Number,
        thresholdGood: {
            type: Number,
            default() {
                return this.$store.getters[
                    "usPreferences/NPS_THRESHOLD_GOOD"
                ] === null
                    ? 25
                    : this.$store.getters["usPreferences/NPS_THRESHOLD_GOOD"];
            },
        },
        thresholdBad: {
            type: Number,
            default() {
                return this.$store.getters[
                    "usPreferences/NPS_THRESHOLD_BAD"
                ] === null
                    ? 0
                    : this.$store.getters["usPreferences/NPS_THRESHOLD_BAD"];
            },
        },
    },
    computed: {
        text() {
            return this.value.toString();
        },
        color: function() {
            if (this.value < this.thresholdBad) {
                return "error";
            } else if (
                this.value >= this.thresholdBad &&
                this.value < this.thresholdGood
            ) {
                return "warning";
            } else {
                return "success";
            }
        },
    },
};
</script>
